import {FieldInput, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FieldInputProps} from '@sollapay/ui/components';

export type FullNameFieldProps = FieldInputProps;

/**
 * A person's full-name input with a consistent icon and placeholder across every screen that
 * captures one. Override `startAdornment`/`placeholder` at the call site when the copy
 * genuinely differs (e.g. the seller/developer form's corporate-vs-individual placeholder).
 * Purely presentational — validation is wired externally via `fullNameRule`, same as every
 * other field in these forms.
 */
export function FullNameField({
  startAdornment,
  placeholder,
  ...fieldInputProps
}: FullNameFieldProps) {
  const {t} = useTranslation();
  return (
    <FieldInput
      {...fieldInputProps}
      placeholder={placeholder ?? t('common:fields.fullName.examplePlaceholder')}
      startAdornment={startAdornment ?? <Icon name="user" className="size-4" />}
    />
  );
}
